export default __webpack_public_path__ + "static/media/kick_avenue_empty_image.cf172573.png";